import { mutate } from "swr";

export const SYSTEMS_LIST_URL = "/api/ai-transform/v1/system";

export function getSystemDetailUrl(systemId: string) {
  return `${SYSTEMS_LIST_URL}?system_id=${encodeURIComponent(systemId)}`;
}

export function matchesSystemsCacheKey(key: unknown, expected: string) {
  const url =
    typeof key === "string"
      ? key
      : Array.isArray(key) && typeof key[0] === "string"
        ? key[0]
        : undefined;

  if (!url) return false;

  // List views use the same endpoint with sort, filter, and pagination query
  // parameters. Treat those variants as the same entity cache family so a
  // mutation immediately reaches cards as well as the detail view.
  return url === expected || url.startsWith(`${expected}?`);
}

export async function revalidateSystemsCache(systemId?: string) {
  await mutate((key) => matchesSystemsCacheKey(key, SYSTEMS_LIST_URL));

  if (systemId) {
    await mutate((key) =>
      matchesSystemsCacheKey(key, getSystemDetailUrl(systemId)),
    );
  }
}
